var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreviousIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M.08 7.76C.027 7.813 0 7.893 0 8a.71.71 0 0 0 .08.32l7.6 7.6c.053.053.133.08.24.08.107 0 .2-.04.28-.12.08-.08.12-.173.12-.28a.71.71 0 0 0-.08-.32L1.36 8.4H15.6c.107 0 .2-.04.28-.12a.384.384 0 0 0 0-.56.384.384 0 0 0-.28-.12H1.36L8.24.72C8.347.613 8.4.507 8.4.4c0-.107-.04-.2-.12-.28A.432.432 0 0 0 7.96 0c-.133 0-.227.027-.28.08L.08 7.76z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousIcon);
export default __webpack_public_path__ + "static/media/previous_icon.430518ad1ca3684c3803773f2455cfb5.svg";
export { ForwardRef as ReactComponent };